import React from 'react'
import { useFormikContext } from 'formik'
import { CreateEventRequest } from '../admin.interfaces'
import {
    SectionTitle,
    Column,
    Row,
    Section,
    WrapRow,
    RatioContainer,
    SectionSeparator,
} from '../../shared/shared.styled'
import TextInput from '../../shared/components/text-input.component'
import Checkbox from '../../shared/components/checkbox.component'

interface EventFieldsProps {
    isEditing?: boolean
}

const EventFields = ({ isEditing = true }: EventFieldsProps) => {
    const { values, handleChange, setFieldValue, errors } =
        useFormikContext<CreateEventRequest>()

    return (
        <Section>
            <Row>
                <SectionTitle>Detalhes do evento</SectionTitle>
            </Row>
            <SectionSeparator />
            <Column style={{ width: '100%' }}>
                <WrapRow style={{ alignItems: 'flex-start' }}>
                    <RatioContainer ratio={1}>
                        <TextInput
                            inEdition={isEditing}
                            required={true}
                            title="Nome"
                            name="name"
                            placeholder="Ex: Private Sales"
                            onChange={handleChange}
                            value={values.name}
                            error={errors.name}
                        />
                    </RatioContainer>
                </WrapRow>
                <WrapRow style={{ alignItems: 'flex-start' }}>
                    <RatioContainer ratio={1 / 2}>
                        <TextInput
                            inEdition={isEditing}
                            required={true}
                            type="date"
                            title="Data de início"
                            name="startDate"
                            onChange={handleChange}
                            value={values.startDate}
                            error={errors.startDate}
                        />
                    </RatioContainer>
                    <RatioContainer ratio={1 / 2}>
                        <TextInput
                            inEdition={isEditing}
                            required={true}
                            type="date"
                            title="Data de fim"
                            name="endDate"
                            onChange={handleChange}
                            value={values.endDate}
                            error={errors.endDate}
                        />
                    </RatioContainer>
                </WrapRow>
                {isEditing && (
                    <WrapRow style={{ alignItems: 'center' }}>
                        <Checkbox
                            label="Ativo no site público"
                            checked={!!values.active}
                            onChange={(e) =>
                                setFieldValue('active', e.target.checked)
                            }
                        />
                    </WrapRow>
                )}
            </Column>
        </Section>
    )
}

export default EventFields
